import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

export default function NotFoundPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Try to match old WordPress URLs to articles
    const path = location.pathname.replace(/^\/+|\/+$/g, "");
    if (!path || path.includes("/")) {
      setChecking(false);
      return;
    }
    // Check if this slug exists as an article
    api.get(`/articles/${path}`)
      .then(() => {
        navigate(`/article/${path}`, { replace: true });
      })
      .catch(() => {
        setChecking(false);
      });
  }, [location.pathname, navigate]);

  if (checking) {
    return (
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-32 text-center">
        <div className="animate-pulse space-y-4">
          <div className="h-12 bg-muted w-1/3 mx-auto" />
          <div className="h-6 bg-muted w-1/2 mx-auto" />
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet><title>404 - Page non trouvée - OFALycée</title></Helmet>
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-32 text-center" data-testid="not-found-page">
        <span className="text-8xl font-heading text-primary/20 block mb-4">404</span>
        <h1 className="font-heading text-3xl md:text-4xl mb-4">Page non trouvée</h1>
        <p className="text-muted-foreground mb-8">La page que vous recherchez n'existe pas ou a été déplacée.</p>
        <Link to="/"><Button className="rounded-none px-8" data-testid="back-home-btn"><ArrowLeft className="h-4 w-4 mr-2" /> Retour à l'accueil</Button></Link>
      </div>
    </>
  );
}
